import { render, staticRenderFns } from "./OrderSelector.vue?vue&type=template&id=decad980&scoped=true"
import script from "./OrderSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderSelector.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./OrderSelector.vue?vue&type=style&index=0&id=decad980&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "decad980",
  null
  
)

export default component.exports